import { render } from "./DownloadVideo.vue?vue&type=template&id=148e3c24"
import script from "./DownloadVideo.vue?vue&type=script&lang=js"
export * from "./DownloadVideo.vue?vue&type=script&lang=js"

import "./DownloadVideo.vue?vue&type=style&index=0&id=148e3c24&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__